import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.restorankrcma.rs";
const DEFAULT_IMAGE = `${SITE_URL}/hero.jpg`;

export function PageSeo({
  title,
  description,
  keywords,
  path = "/",
  type = "website",
  image = DEFAULT_IMAGE
}) {
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="RESTORAN KRČMA" />
      <meta property="og:locale" content="sr_RS" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
